import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';
import { RedcatApiHandler } from 'polygon-utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeProfile } from '../slices/profile';
import { fetchSavedCards } from './fetchSavedCards';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

export const fetchProfile = createAsyncThunk(
  'fetchProfile',
  async (_data: undefined, { dispatch, rejectWithValue: _, getState }) => {
    const path = '/api/v1/profile';

    const gatewayType = getGatewayType(getState() as EntireFrontendState);

    return RedcatApiHandler.authorisedFetch({ method: 'GET', path }).then(
      (response: { data: RawMember }) => {
        dispatch(storeProfile(response.data));

        if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
          dispatch(fetchSavedCards());
        }
      },
    );
  },
);
